import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { FooterGlowProvider } from './context/FooterGlowContext';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Portraits from './pages/Portraits';
import Headshots from './pages/Headshots';
import RealEstate from './pages/RealEstate';
// import Blog from './pages/Blog'; // Blog page deactivated
import Booking from './pages/Booking';
import Footer from './components/Footer';

function App() {
  return (
    <FooterGlowProvider>
      <Router>
        <div className="App">
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/portraits" element={<Portraits />} />
              <Route path="/headshots" element={<Headshots />} />
              <Route path="/real-estate" element={<RealEstate />} />
              {/* <Route path="/blog" element={<Blog />} /> */} {/* Blog page deactivated */}
              <Route path="/booking" element={<Booking />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </FooterGlowProvider>
  );
}

export default App; 